const publicKey = 'Yjr7MR67dKP6MbHaJ';
const templateKey = 'template_ek4pqg3';
const serviceID = 'service_yuwqjof';

export { publicKey, templateKey, serviceID };
